import React from "react";

export default function WeightBlock({
	weight,
	handleWeightChange,
	willBeRounded,
	isVolume,
}) {
	return (
		<div className="rounded-2xl border bg-white p-4">
			<h4 className="font-semibold text-gray-900">Weight</h4>

			<div className="mt-2">
				<label className="subtext text-xs text-gray-500">
					Package weight (kg)
				</label>

				<input
					type="text"
					inputMode="decimal"
					value={weight}
					onChange={handleWeightChange}
					placeholder="e.g. 2.3"
					className="mt-1 w-full p-3 border border-gray-300 rounded-xl input-focus"
				/>

				{willBeRounded && (
					<p className="subtext mt-2 text-xs text-gray-700">
						Your entered weight will be rounded <b>up</b> to the
						next {isVolume ? "1.0" : "0.5"} kg tier.
					</p>
				)}
			</div>
		</div>
	);
}
